// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"73":"9a597089","153":"bf0857d9","482":"38321330"}[chunkId] + ".chunk.css";
};